import * as turf from '@turf/turf';
import _ from 'lodash';
import moment from 'moment';
import api from '../api';
import dataBoard from '../core/databoard';
import dialogBox from '../core/dialog';
import infoBoard from '../core/infoboard';
import translate from '../core/tools/translate';
import environment from '../environment';

import ShapesInfo from './ShapesInfo';

const LayerControls = (name) => require('../controls').get(name);
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

class VoronoiInfo extends ShapesInfo {
    constructor () {
        const name = 'Voronoi';

        const options = {
            layer: LayerControls(name).getLayer(),
            label: translate(`Common.${name}`),
            name,
            id: 'voronoi',
            context: 'voronoi'
        };

        super(options);
    }

    static getInstance () {
        if (!VoronoiInfo._instance) {
            VoronoiInfo._instance = new VoronoiInfo();
        }

        return VoronoiInfo._instance;
    }

    _hasActions () { return false; }

    _hasSummary () { return true; }

    _getContainer () {
        return infoBoard.createContainer({
            id: this.options.name,
            name: this.options.label,
            actions: false
        });
    }

    create (features) {
        // console.time('Shapes -> create');
        super.create(this.validateFeatures(features));
    }

    validateFeatures (features) {
        if (!this.isDynamicType()) {
            features = _(features)
                .groupBy(f => f.properties.IdAgrupamento)
                .map((f) => {
                    return _.reduce(f, (acc, feat) => {
                        acc = !acc ? feat : turf.union(acc, feat);
                        return acc;
                    });
                }).value();
        }

        return features;
    }

    isDynamicType () {
        return LayerControls(this.options.name).getTypeValue(true) === environment.get('TYPE.DYNAMIC');
    }

    highlight (feature, options = {}, inverse = false) {
        if (LayerControls(this.options.name).getTypeValue(true) === environment.get('TYPE.DYNAMIC')) {
            return;
        }

        try {
            const layers = this.getLayer().layer.getLayers();
            return layers.filter(f => String(f.properties.IdAgrupamento) === String(feature.properties.IdAgrupamento)).each((f, i) => {
                options.layer = layers[i];
                if (inverse) {
                    this.getLayer().unhighlight(f, options);
                } else {
                    this.getLayer().highlight(f, options);
                }
            });
        } catch (err) {
            console.log(err);
        }
    }

    unhighlight (feature, options = {}) {
        this.highlight(feature, options, true);
    }

    blank () {
        // console.time('Shapes -> blank');
        if (LayerControls(this.options.name).getTypeValue(true) === environment.get('TYPE.DYNAMIC')) {
            return;
        }

        try {
            _(this.getLayer().getCurrentFeatures())
                .groupBy(f => f.properties.IdAgrupamento)
                .map(f => {
                    return _.reduce(f, (acc, feat) => {
                        acc = !acc ? feat : turf.union(acc, feat);
                        return acc;
                    });
                })
                .filter(f => !this.check(f.properties.id))
                .forEach(f => this.unhighlight(f.properties.id));
        } catch (err) {
            console.log(err);
        }

        // console.timeEnd('Shapes -> blank');
    }

    add (feature, layer) {
        const $el = $(`#${this.options.name}-tab`).find('[name="selected-location"]');
        $el.each((i, el) => {
            if (el.id.indexOf(feature.properties.IdAgrupamento) === -1) {
                $(el).iCheck('uncheck');
            }
        });

        super.add(feature, layer);
        LayerControls(this.options.name).reload();
    }

    _filterByLocation (state) {
        if (state && this.getEntry().size === 0) {
            return this._selectOneAreaMessage('FilterLocation');
        }

        const values = [];
        this.getEntry().forEach((status, id) => values.push(id));

        const { filter = {} } = this.options.layer;
        if (!filter.properties) {
            filter.properties = {};
        }

        if (state && this.getEntry().size > 0) {
            filter.properties.IdAgrupamento = values;
        } else {
            if (filter.properties.IdAgrupamento) {
                delete filter.properties.IdAgrupamento;
            }
        }

        this.getLayer().setOptions({ filter });
        if (LayerControls(this.options.name).check()) {
            this.getLayer().reload();
        }
    }
}

export default VoronoiInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/VoronoiInfo.js